var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#12BFE0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_1621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.76471 13.5786C6.76471 14.1718 7.25 14.6571 7.84314 14.6571H12.1569C12.75 14.6571 13.2353 14.1718 13.2353 13.5786V7.10803H6.76471V13.5786ZM8.09118 9.73941L8.85148 8.97911L10 10.1222L11.1431 8.97911L11.9034 9.73941L10.7603 10.8825L11.9034 12.0257L11.1431 12.786L10 11.6428L8.85687 12.786L8.09657 12.0257L9.23971 10.8825L8.09118 9.73941ZM11.8873 5.49039L11.348 4.95117H8.65197L8.11275 5.49039H6.22549V6.56882H13.7745V5.49039H11.8873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_1621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9412,
    height: 12.9412,
    fill: "white",
    transform: "translate(3.52942 3.3335)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.99c16e57338077b51f384bb4601e4b4d.svg";
export { ForwardRef as ReactComponent };